import styled from 'styled-components';

export default styled.div`
	--v-pad: var(--spacing-x-large);
	--h-pad: var(--spacing-xxx-large);
	display: flex;
	flex-direction: column;
	padding: var(--v-pad) var(--h-pad);
	gap: var(--v-pad);
	min-height: 100%;
	.last-refreshed {
		justify-content: end;
	}
	.insight-select-filter {
		max-width: var(--px-300);
	}
`;
